import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface FieldReference {
  id: string;
  name: string;
  path: string;
  displayName?: string;
  selected?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FieldReferenceService {

  constructor(protected http: HttpClient) { }
  
  getFieldReferences(entity: string): Observable<FieldReference[]> {
    return this.http.get<FieldReference[]>(`json/field-references/${entity}`);
  }
}
